export default {
  getFoto: state => () => state.anexos.find(anexo => anexo.tipoAnexo === 'FOTO_PERFIL'),
  getAssinatura: state => () => state.anexos.find(anexo => anexo.tipoAnexo === 'ASSINATURA'),
}
